import useFetchTeamMembers from 'queries/fetch/fetchTeamMembers.ts';
import { UserInfo } from 'schemas/UserInfo.schema';

const useTeamReviewers = (teamId: string, iterationCreator: UserInfo) => {
  const { data, error, isLoading } = useFetchTeamMembers();

  if (!data) {
    return {
      possibleReviewers: [],
      isLoading: true,
      error: null,
    };
  }

  return {
    possibleReviewers: (data?.[teamId!]?.approve ?? []).filter((user) => {
      const hasUserInfo = user.email || (user.given_name && user.family_name) || user.sub;
      const isNotIterationCreator = iterationCreator.id !== user.sub;

      return hasUserInfo && isNotIterationCreator;
    }),
    isLoading,
    error,
  };
};

export default useTeamReviewers;
